import { Link, NavLink, Navigate, Outlet, useLocation } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";

export default function AdminLayout() {
  const { user, checked, logout } = useAuth();
  const location = useLocation();

  if (!checked) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f3f3f0] text-[#5d5f64]">
        Checking session…
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }

  const linkClass = ({ isActive }) =>
    `block px-4 py-3 text-sm border-l-2 ${
      isActive
        ? "border-[#16181c] bg-white text-[#16181c] font-medium"
        : "border-transparent text-[#5d5f64] hover:text-[#16181c] hover:bg-white/50"
    }`;

  return (
    <div className="min-h-screen bg-[#f3f3f0] flex" data-testid="admin-layout">
      <aside className="w-64 border-r border-[#e3e3e1] bg-[#f3f3f0] flex flex-col">
        <div className="px-6 py-6 border-b border-[#e3e3e1]">
          <Link to="/admin" className="flex items-center gap-3">
            <span className="inline-block w-3.5 h-3.5 bg-[#16181c]" />
            <span className="font-display font-bold text-[#16181c]">Cipta Andalan</span>
          </Link>
          <div className="text-[11px] uppercase tracking-wider text-[#5d5f64] mt-1 ml-6">CMS</div>
        </div>
        <nav className="py-4 flex-1" data-testid="admin-sidebar">
          <NavLink to="/admin" end className={linkClass} data-testid="admin-nav-dashboard">
            Dashboard
          </NavLink>
          <NavLink to="/admin/projects" className={linkClass} data-testid="admin-nav-projects">
            Projects
          </NavLink>
          <NavLink to="/admin/categories" className={linkClass} data-testid="admin-nav-categories">
            Categories
          </NavLink>
          <NavLink to="/admin/leads" className={linkClass} data-testid="admin-nav-leads">
            Inbox · Leads
          </NavLink>
          <NavLink to="/admin/content" className={linkClass} data-testid="admin-nav-content">
            Homepage content
          </NavLink>
          <NavLink to="/admin/logo" className={linkClass} data-testid="admin-nav-logo">
            Brand & contact
          </NavLink>
        </nav>
        <div className="border-t border-[#e3e3e1] px-6 py-4 text-xs text-[#5d5f64]">
          <div className="mb-2">{user.email}</div>
          <button
            onClick={logout}
            className="inline-flex items-center gap-2 text-[#16181c] hover:text-[#5d5f64]"
            data-testid="admin-logout"
          >
            <LogOut size={14} /> Sign out
          </button>
        </div>
        <div className="px-6 py-3 border-t border-[#e3e3e1] text-xs">
          <Link to="/" className="text-[#5d5f64] hover:text-[#16181c]">
            View site →
          </Link>
        </div>
      </aside>
      <main className="flex-1 overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}
